import { PackingStatus } from "@gtpl/shared-models/common-models";
import { FgStockStatusEnum } from "./fg-stock-status.enum";
import { StockStatus } from "../../../../../../apps/services/warehouse-service/src/app/stock/dto/stock-status.enum";

export class SuggestPalletRequest {
    saleOrderItemId: number;
    location?: number;
    stockType?: StockStatus;
    pouchesShortage?: PackingStatus;
    cartonsShortage?: PackingStatus;
    productCategory?:string;
    packStyleId?:number;
    antibioticTestResult ?: boolean
   
    constructor(saleOrderItemId: number,location?: number, stockType?: StockStatus, pouchesShortage?: PackingStatus,
        cartonsShortage?: PackingStatus,productCategory?:string, packStyleId?:number,antibioticTestResult ?: boolean){
        this.saleOrderItemId = saleOrderItemId;
        this.location = location;
        this.stockType = stockType;
        this.pouchesShortage =  pouchesShortage;
        this.cartonsShortage =  cartonsShortage;
        this.productCategory =  productCategory;
        this.packStyleId =  packStyleId;
        this.antibioticTestResult = antibioticTestResult
    }
}
